import React from 'react'
import { Menu, MenuButton, MenuList, MenuItem, Flex } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import { PopType } from '../../types'
import { ChevronDown } from 'lucide-react'
import { linkPopLiterals } from 'components/PopOverview/model/literals'

interface PopTypeSelectorProps {
  value: number
  onChange: (value: number) => void
}

export const PopTypeSelector: React.FC<PopTypeSelectorProps> = ({ value, onChange }) => {
  const types = [
    { value: PopType.Default, label: 'default_pop' },
    { value: PopType.RePop, label: 'repop' },
    { value: PopType.ChatGpt, label: 'chat_gpt_pop' },
    { value: PopType.FakeRe, label: 'fake_repop' },
    { value: PopType.AiPop, label: 'ai_pop' },
    { value: PopType.AiRePop, label: 'ai_repop' },
    { value: PopType.ActionPop, label: 'action_pop' },
    { value: PopType.LinkPop, label: linkPopLiterals.type },
  ]

  const label = types.find((t) => t.value === value)?.label || 'select_pop_type'

  return (
    <Menu>
      <MenuButton
        as={Flex}
        borderRadius="5px"
        border="1px solid #E0E0E0"
        p="10px"
        w="max-content"
        maxW="300px"
        alignItems="center"
        justifyContent="space-between"
        style={{ columnGap: '10px' }}
        cursor="pointer"
        bg="white"
      >
        <LocaleText text={label} isLocalUse={typeof label === 'string'} />
        <ChevronDown size={16} strokeWidth={2.5} />
      </MenuButton>
      <MenuList>
        {types.map((type) => (
          <MenuItem key={type.value} onClick={() => onChange(type.value)}>
            <LocaleText text={type.label} isLocalUse={typeof type.label === 'string'} />
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}
